// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .confirmPopupTitle {
  font-size: var(--dialogTitleFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--dialogTitleFontWeight);
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .confirmPopupContent {
  font-size: var(--dialogContentFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--dialogContentFontWeight);
  list-style: none;
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .confirmPopupContent
  .primaryColored {
  color: var(--button-color);
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .confirmPopupContent
  .highlightBold {
  font-weight: var(--header-FontWeight);
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  p {
  margin: 0px;
}

.MuiPaper-root[aria-describedby='noTitle_CenterAligned textAlignCentre']
  .MuiDialogActions-root {
  display: flex !important;
  justify-content: center !important;
  text-align: center;
}

.ta-center {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/confirmPopupRenderer/ConfirmPopupRenderer.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;;EAIE,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;;;;EAIE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;;;;EAKE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,qCAAqC;AACvC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .confirmPopupTitle {\n  font-size: var(--dialogTitleFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--dialogTitleFontWeight);\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .confirmPopupContent {\n  font-size: var(--dialogContentFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--dialogContentFontWeight);\n  list-style: none;\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .confirmPopupContent\n  .primaryColored {\n  color: var(--button-color);\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .confirmPopupContent\n  .highlightBold {\n  font-weight: var(--header-FontWeight);\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  p {\n  margin: 0px;\n}\n\n.MuiPaper-root[aria-describedby='noTitle_CenterAligned textAlignCentre']\n  .MuiDialogActions-root {\n  display: flex !important;\n  justify-content: center !important;\n  text-align: center;\n}\n\n.ta-center {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
